export default __webpack_public_path__ + "static/media/logo.f3ef4072.svg";